export default function L10n(l10nService, $parse) {
    'ngInject';

        /**
         * Template for localization
         */
        const template = '{{ ::localizedText }}';

        return {
            restrict: 'EA',
            scope: true,
            compile: function(tElement) {
                const originalText = tElement.text();
                tElement.html(template);

                return {
                    pre: function(scope) {
                        let parsedText;

                        /**
                         * If we have binding we parsing this value
                         */
                        if (originalText.indexOf('{') !== -1 && originalText.indexOf('{') !== -1) {
                            parsedText = originalText.replace('{{', '').replace('}}', '');
                            parsedText = $parse(parsedText)(scope);
                        }

                        scope.localizedText = l10nService.localize(parsedText || originalText);
                    },
                    post: function(scope, element, attributes) {

                        /**
                         * If there is no additional logic in attrs like ng-class etc.
                         * we remove tag completely
                         */
                        if (!Object.keys(attributes.$attr).length) {
                            element.replaceWith(scope.localizedText);
                        }
                    },
                };
            },
        };
}



// WEBPACK FOOTER //
// ./src/app/directives/l10n.directive.js